// extracted by mini-css-extract-plugin
export default {"cell":"Emotion_cell__+CJ-V","up":"Emotion_up__LJbTr","down":"Emotion_down__Us3h1","svgContainer":"Emotion_svgContainer__-RGnh"};